// Soft, slate-tinted elevation. Low levels are for cards/menus; borders do most of
// the separation work, especially in dark mode where shadows barely show.
export const shadows = () => [
  'none',
  '0px 1px 4px rgba(15,23,42,0.066),0px 1px 2px rgba(15,23,42,0.04)',
  '0px 1px 6px rgba(15,23,42,0.072),0px 1px 3px rgba(15,23,42,0.04)',
  '0px 2px 8px rgba(15,23,42,0.078),0px 1px 4px rgba(15,23,42,0.04)',
  '0px 2px 10px rgba(15,23,42,0.084),0px 1px 5px rgba(15,23,42,0.04)',
  '0px 2px 12px rgba(15,23,42,0.090),0px 1px 6px rgba(15,23,42,0.04)',
  '0px 3px 14px rgba(15,23,42,0.096),0px 2px 7px rgba(15,23,42,0.04)',
  '0px 4px 16px rgba(15,23,42,0.102),0px 2px 8px rgba(15,23,42,0.04)',
  '0px 4px 18px rgba(15,23,42,0.108),0px 2px 9px rgba(15,23,42,0.04)',
  '0px 4px 20px rgba(15,23,42,0.114),0px 2px 10px rgba(15,23,42,0.04)',
  '0px 5px 22px rgba(15,23,42,0.120),0px 2px 11px rgba(15,23,42,0.04)',
  '0px 6px 24px rgba(15,23,42,0.126),0px 3px 12px rgba(15,23,42,0.04)',
  '0px 6px 26px rgba(15,23,42,0.132),0px 3px 13px rgba(15,23,42,0.04)',
  '0px 6px 28px rgba(15,23,42,0.132),0px 3px 14px rgba(15,23,42,0.04)',
  '0px 7px 30px rgba(15,23,42,0.132),0px 4px 15px rgba(15,23,42,0.04)',
  '0px 8px 32px rgba(15,23,42,0.132),0px 4px 16px rgba(15,23,42,0.04)',
  '0px 8px 34px rgba(15,23,42,0.132),0px 4px 17px rgba(15,23,42,0.04)',
  '0px 8px 36px rgba(15,23,42,0.132),0px 4px 18px rgba(15,23,42,0.04)',
  '0px 9px 38px rgba(15,23,42,0.132),0px 4px 19px rgba(15,23,42,0.04)',
  '0px 10px 40px rgba(15,23,42,0.132),0px 5px 20px rgba(15,23,42,0.04)',
  '0px 10px 42px rgba(15,23,42,0.132),0px 5px 21px rgba(15,23,42,0.04)',
  '0px 10px 44px rgba(15,23,42,0.132),0px 5px 22px rgba(15,23,42,0.04)',
  '0px 11px 46px rgba(15,23,42,0.132),0px 6px 23px rgba(15,23,42,0.04)',
  '0px 12px 48px rgba(15,23,42,0.132),0px 6px 24px rgba(15,23,42,0.04)',
  '0px 12px 50px rgba(15,23,42,0.132),0px 6px 25px rgba(15,23,42,0.04)'
];
